// Minimal nav rail for B.1.5 Task 1. Task 3 evolves the styling +
// active-link affordance; for now the links exist so /fleet works
// end-to-end and the operator can reach /accounts / /audit once
// those routes ship in Phase B / C.

import { Link } from "@tanstack/react-router";

const ITEMS: ReadonlyArray<{ to: string; label: string }> = [
  { to: "/fleet", label: "Fleet" },
  { to: "/accounts", label: "Accounts" },
  { to: "/allocation", label: "Allocation" },
  { to: "/onboarding-runs", label: "Onboarding" },
  { to: "/audit", label: "Audit" },
];

export function Sidebar() {
  return (
    <nav
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
        padding: "16px 8px",
        borderRight: "1px solid var(--border)",
        minWidth: 160,
        background: "var(--surface)",
      }}
    >
      {ITEMS.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          activeOptions={{ exact: false }}
          activeProps={{
            style: {
              background: "var(--surface-2)",
              color: "var(--text)",
              borderColor: "var(--border)",
            },
          }}
          style={{
            display: "block",
            padding: "8px 12px",
            borderRadius: 6,
            color: "var(--text-dim)",
            fontSize: "0.9rem",
            textDecoration: "none",
            border: "1px solid transparent",
          }}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
}
